'use client';

import tinycolor from "../../../external/tinycolor2/esm/tinycolor.js";
import { getOnActionColor } from "./getOnActionColor.js";
const calibrateLight = (lightness, amount) => Math.max(0, Math.min(100, (100 - lightness) * amount));
const calibrateDark = (lightness, amount) => Math.max(0, Math.min(100, lightness * amount));
const getThemedPalette = (primaryColor) => {
  if (tinycolor(primaryColor).isValid()) {
    const lightness = tinycolor(primaryColor).toHsl().l * 100;
    const lightest = tinycolor(primaryColor).lighten(calibrateLight(lightness, 0.9)).toHexString();
    const light = tinycolor(primaryColor).lighten(calibrateLight(lightness, 0.75)).toHexString();
    const base = tinycolor(primaryColor).lighten(calibrateLight(lightness, 0.5)).toHexString();
    const dark = tinycolor(primaryColor).toHexString();
    const darkest = tinycolor(primaryColor).darken(calibrateDark(lightness, 0.2)).toHexString();
    return {
      action: {
        primary: {
          lightest,
          light,
          base,
          dark,
          darkest
        }
      },
      onAction: {
        primary: {
          lightest: getOnActionColor(lightest),
          light: getOnActionColor(light),
          base: getOnActionColor(base),
          dark: getOnActionColor(dark),
          darkest: getOnActionColor(darkest)
        }
      }
    };
  }
  return void 0;
};
export {
  getThemedPalette
};
